var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 20,
    height: 20,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M19.352,8.737,11.091.476a1.479,1.479,0,0,0-.542-.352,1.652,1.652,0,0,0-1.256,0,1.479,1.479,0,0,0-.542.352L.491,8.737a1.64,1.64,0,0,0,0,2.339,1.64,1.64,0,0,0,2.339,0L8.269,5.631V18.168a1.652,1.652,0,0,0,3.3,0V5.631l5.439,5.446a1.654,1.654,0,1,0,2.339-2.339",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.11333cfafeed204658b226f6f6280ac1.svg";
export { ForwardRef as ReactComponent };